import { Action, ActionReducer, ActionReducerMap, createReducer, MetaReducer, on } from '@ngrx/store';
import { environment } from '../../environments/environment';
import { SettingsState } from '../desktop/settings/store/settings.reducer';
import * as AppActions from './app.actions';
import * as fromAuth from '../auth/store/auth.reducer';
import { Locale } from '@app/interfaces/locale.interface';

export interface AllLocalesState {
  allLocales: Locale[] | null;
  allLocalesLoading: boolean;
  allLocalesError: any;
}

export interface AppState extends fromAuth.AuthState, AllLocalesState {
  settings?: SettingsState;
}

export const appInitialState: AppState = {
  ...fromAuth.initialAuthState,
  allLocales: null,
  allLocalesLoading: false,
  allLocalesError: null
};

export const appReducer = createReducer(
  appInitialState,
  on(AppActions.loadAllLocales, (state) => ({ ...state, allLocalesLoading: true })),
  on(AppActions.loadAllLocalesSuccess, (state, { locales }) => ({
    ...state,
    allLocales: locales,
    allLocalesLoading: false
  })),
  on(AppActions.loadAllLocalesFailure, (state, { error }) => ({
    ...state,
    allLocalesLoading: false,
    allLocalesError: error
  }))
);

export const reducers: ActionReducerMap<any> = {
  app: appReducer,
};

export function clearStateMetaReducer<State extends {}>(reducer: ActionReducer<State>): ActionReducer<State> {
  return function clearStateFn(state: State, action: Action) {
    if (['[Auth] User Logout', '[Auth] Switch Customer', '[Auth] User Force Logout'].includes(action.type)) {
      state = {} as State;
    }
    return reducer(state, action);
  };
}

export const metaReducers: MetaReducer<AppState>[] =
  !environment.production ? [clearStateMetaReducer] : [clearStateMetaReducer];
